/**
 * WorkSpace Icon — "Arbeit" Life Space
 *
 * Briefcase icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * @example
 * <WorkSpaceIcon size={16} />
 */
export const WorkSpaceIcon = ({ size = 16, color }: { size?: number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.67 3.67V0.67H10.66V3.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.67 3.67H14.66C14.93 3.67 15.18 3.77 15.37 3.96C15.56 4.15 15.66 4.4 15.66 4.67V9.67H0.67V4.67C0.67 4.4 0.77 4.15 0.96 3.96C1.15 3.77 1.4 3.67 1.67 3.67Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.66 11.66V13.66C14.66 13.93 14.56 14.18 14.37 14.37C14.18 14.56 13.93 14.66 13.66 14.66H2.67C2.4 14.66 2.15 14.56 1.96 14.37C1.77 14.18 1.67 13.93 1.67 13.66V11.66"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
